import { render, staticRenderFns } from "./inputDate.vue?vue&type=template&id=2fbf52b2"
import script from "./inputDate.vue?vue&type=script&lang=js"
export * from "./inputDate.vue?vue&type=script&lang=js"
import style0 from "./inputDate.vue?vue&type=style&index=0&id=2fbf52b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports